<lx-quote-course-details
  class="quote__course-details"
  [quote]="quote"
  [isOnlineFlow]="isOnlineFlow"
  [areQuoteTypesAdultAndOnline]="areQuoteTypesAdultAndOnline"
  [isQuoteSlotExpanded]="isQuoteSlotExpanded"
  [languageLabel]="languageLabel"
  [languageName]="languageName"
  [schoolLabel]="schoolLabel"
  [destination]="destination"
  [currentSchoolName]="currentSchoolName"
  [currentCourses]="currentCourses"
  [courseDurationLabel]="courseDurationLabel"
  [quoteType]="quote?.input?.quoteType"
  (editButtonClicked)="editCourseDetails($event)"
></lx-quote-course-details>

<lx-quote-subtotal-item
  class="quote__products"
  [currency]="currency"
  [totalItems]="quote?.products?.length"
  [totalLabel]="itemTotalMessage"
  [amountTotal]="quote?.productTotal"
  [decimalPlaces]="decimalPlaces"
  [roundedElements]="roundedElements"
  (expandAccordion)="expandProductAccordions.emit()"
  [isAccordionExpanded]="isProductsAccordionExpanded"
></lx-quote-subtotal-item>

<ng-container *ngFor="let product of getTuitions()">
  <ng-container
    *ngTemplateOutlet="
      productsTemplate;
      context: {
        products: [product],
        nullMessage: courseNullMessage,
        expand: isProductsAccordionExpanded
      }
    "
  ></ng-container>
</ng-container>
<ng-container
  *ngIf="isJuniorsFlow && premiumResidenceAvailable"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxProductsByType : productTypes.PREMIUM_RESIDENCE,
    productType: productTypes.PREMIUM_RESIDENCE,
    nullMessage: displayNoPremiumResidence ? premiumResidenceNullMessage : '',
    expand: isProductsAccordionExpanded
  }"
></ng-container>
<ng-container
  *ngIf="areQuoteTypesAdultAndOnline || !isOnlineFlow"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxTransfersByType : transferServiceTypes.ARRIVAL,
    productType: productTypes.TRANSFER,
    nullMessage: displayNoTransfer ? arrivalTransferNullMessage : '',
    expand: isProductsAccordionExpanded
  }"
></ng-container>
<ng-container
  *ngIf="areQuoteTypesAdultAndOnline || !isOnlineFlow"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxTransfersByType : transferServiceTypes.DEPARTURE,
    productType: productTypes.TRANSFER,
    nullMessage: displayNoTransfer ? departureTransferNullMessage : '',
    expand: isProductsAccordionExpanded
  }"
></ng-container>
<ng-container
  *ngIf="areQuoteTypesAdultAndOnline || !isOnlineFlow"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxProductsByType : productTypes.INSURANCE,
    productType: productTypes.INSURANCE,
    nullMessage: displayNoInsurance ? insuranceNullMessage : '',
    expand: isProductsAccordionExpanded
  }"
></ng-container>
<ng-container
  *ngIf="isJuniorsFlow"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxProductsByType : productTypes.PREMIUM_ACTIVITIES,
    productType: productTypes.PREMIUM_ACTIVITIES,
    nullMessage: premiumActivitiesNullMessage,
    expand: isProductsAccordionExpanded
  }"
></ng-container>
<ng-container
  *ngIf="isJuniorsFlow"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxProductsByType : productTypes.PRIVATE_LESSONS,
    productType: productTypes.PRIVATE_LESSONS,
    nullMessage: privateLessonsNullMessage,
    expand: isProductsAccordionExpanded
  }"
></ng-container>
<!-- TODO: Review if this works-->
<ng-container
  *ngIf="isJuniorsFlow"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxUnaccompaniedMinorsByType,
    productType: productTypes.TRANSFER,
    nullMessage: unaccompaniedMinorsNullMessage,
    expand: isProductsAccordionExpanded
  }"
></ng-container>
<ng-container *ngIf="!isPackage">
  <ng-container
    *ngIf="areQuoteTypesAdultAndOnline || !isOnlineFlow"
    [ngTemplateOutlet]="productsTemplate"
    [ngTemplateOutletContext]="{
      products: quote?.products | lxProductsByType : productTypes.ACCOMMODATION,
      productType: productTypes.ACCOMMODATION,
      nullMessage: displayNoAccommodation ? accommodationNullMessage : '',
      expand: isProductsAccordionExpanded
    }"
  ></ng-container>
</ng-container>

<ng-container
  *ngIf="availableOptOutProduct"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: quote?.products | lxProductsByType : productTypes.OPT_OUT,
    productType: productTypes.OPT_OUT,
    nullMessage: NA,
    expand: isProductsAccordionExpanded
  }"
></ng-container>

<ng-container
  *ngIf="areQuoteTypesAdultAndOnline || !isOnlineFlow"
  [ngTemplateOutlet]="productsTemplate"
  [ngTemplateOutletContext]="{
    products: fees,
    productType: productTypes.FEE,
    nullMessage: feeNullMessage,
    expand: isProductsAccordionExpanded
  }"
></ng-container>

<ng-container *ngFor="let product of [].concat(otherProducts || [], [].constructor(remainingOtherProductsLength))">
  <ng-container *ngTemplateOutlet="productsTemplate; context: { products: [product], expand: isProductsAccordionExpanded }"></ng-container>
</ng-container>

<ng-container *ngIf="discountsStack || quote?.discounts?.length">
  <lx-quote-discount-details
    class="quote__discounts"
    [quoteKey]="quoteKey"
    [quoteOutputsExpirationDates]="quoteOutputsExpirationDates"
    [activeQuoteSlot]="activeQuoteSlot"
    [discounts]="quote?.discounts"
    [discountTotal]="quote?.discountTotal"
    [currency]="currency"
    [decimalPlaces]="decimalPlaces"
    [isDiscountsAccordionExpanded]="isDiscountsAccordionExpanded"
    [roundedElements]="roundedElements"
    [remainingDiscountsLength]="remainingDiscountsLength"
    (expandDiscountAccordions)="expandDiscountAccordions.emit()"
  ></lx-quote-discount-details>
</ng-container>

<lx-quote-price-checklist
  *ngIf="keyPoints?.included?.length"
  [icon]="KeyPointIcons.INCLUDED"
  [label]="includedMessage"
  [currency]="currency"
  [keyPoints]="keyPoints.included"
  [decimalPlaces]="decimalPlaces"
></lx-quote-price-checklist>

<lx-quote-price-checklist
  *ngIf="keyPoints?.notIncluded?.length"
  [icon]="KeyPointIcons.EXCLUDED"
  [label]="notIncludedMessage"
  [currency]="currency"
  [keyPoints]="keyPoints.notIncluded"
  [decimalPlaces]="decimalPlaces"
></lx-quote-price-checklist>

<lx-quote-total-price
  [ngClass]="totalClass"
  [quote]="quote"
  [quoteKey]="quoteKey"
  [activeQuoteSlot]="activeQuoteSlot"
  [selectedCurrency]="currency"
  [hasCurrencySelector]="hasCurrencySelector"
  [filterVisibleCurrencies]="filterVisibleCurrencies"
  [displayDestinationCurrency]="displayDestinationCurrency"
  [hasDisclaimerSection]="hasDisclaimerSection"
  [infoDisclaimer]="confirmationDisclaimer"
  [showDecimals]="!hideDecimals"
  [showBothCurrencies]="depositsIsEnabled"
  (currencyChanged)="onCurrencyChange($event)"
></lx-quote-total-price>

<div class="quote__cta" *ngIf="showCta">
  <lx-button
    class="quote__button-email"
    [disabled]="disabledCta"
    [block]="true"
    buttonStyle="primary"
    [btnRounded]="roundedElements"
    data-qa="enrolment-mail-quotes"
    (buttonClick)="submitQuote.emit()"
    *ngIf="!(depositsIsEnabled && displayEnrolmentButton); else displayEnrolNow"
    [lxGAClickEvent]="googleAnalyticsEmailQuoteEvent"
  >
    <div class="quote__button-email-header">{{ ctaButtonHeaderText }}</div>
    <div class="quote__button-email-subheader">{{ ctaButtonSubheaderText }}</div>
  </lx-button>
  <ng-template #displayEnrolNow>
    <lx-button
      class="quote__button-enrol"
      [block]="true"
      buttonStyle="primary"
      [btnRounded]="roundedElements"
      buttonId="enrol-now-1"
      data-qa="enrolment-enrol-now"
      i18n-text
      text="Enrol now"
      (buttonClick)="triggerEnrolment()"
      [lxGAClickEvent]="googleAnalyticsEnrolNowEvent"
    ></lx-button>
  </ng-template>
</div>

<div class="quote__actions" *ngIf="hasEditButton || hasRemoveButton">
  <lx-button
    *ngIf="hasEditButton"
    i18n-text
    text="Edit"
    [svg]="modifyQuoteType.Edit"
    [style]="{ marginInlineEnd: '10px' }"
    [hasText]="isQuoteSlotExpanded"
    [svgColor]="'primary'"
    [btnRounded]="true"
    [uppercase]="true"
    [buttonStyle]="'quaternary'"
    (buttonClick)="modifyQuote.emit(modifyQuoteType.Edit)"
    [lxGAClickEvent]="googleAnalyticsEditQuoteEvent"
  >
  </lx-button>
  <lx-button
    *ngIf="hasRemoveButton"
    i18n-text
    text="Remove"
    [svg]="modifyQuoteType.Remove"
    [hasText]="isQuoteSlotExpanded"
    [svgColor]="'primary'"
    [btnRounded]="true"
    [uppercase]="true"
    [buttonStyle]="'quaternary'"
    (buttonClick)="modifyQuote.emit(modifyQuoteType.Remove)"
    [lxGAClickEvent]="googleAnalyticsRemoveQuoteEvent"
  >
  </lx-button>
</div>

<ng-template #productsTemplate let-products="products" let-nullMessage="nullMessage" let-expand="expand" let-productType="productType">
  <div class="quote__products-accordion" *ngIf="(products?.length || nullMessage) && expand" @accordionAnimation>
    <ng-container *ngFor="let product of products">
      <lx-quote-product-details
        [product]="product"
        [quoteKey]="quoteKey"
        [currency]="currency"
        [countryCode]="quote.input.countryCode"
        [decimalPlaces]="decimalPlaces"
        [currentCourses]="currentCourses"
        [isQuoteSlotExpanded]="isQuoteSlotExpanded"
        [isAccommodationMandatory]="isAccommodationMandatory"
        (infoButtonClicked)="openPopup.emit({ productType, productOptions: product })"
        (editButtonClicked)="openPopup.emit({ productType, productOptions: product })"
        (removeButtonClicked)="removeQuote.emit({ productType, productOptions: product })"
      ></lx-quote-product-details>
    </ng-container>
    <div *ngIf="!products?.length && nullMessage" class="quote__empty">
      <div class="quote__label--empty">{{ nullMessage }}</div>
      <lx-quote-cta-button
        *ngIf="
          isQuoteSlotExpanded &&
          this.quote?.input?.quoteType !== AgeGroups.Online &&
          (productType !== productTypes.PREMIUM_RESIDENCE || premiumResidenceAddable) &&
          productType !== productTypes.OPT_OUT
        "
        (buttonClicked)="openPopup.emit({ productType: productType })"
      ></lx-quote-cta-button>
    </div>
  </div>
</ng-template>
